export default __webpack_public_path__ + "static/media/english-to-swedish-screenshot-01.95b77b63.png";